module.exports = __webpack_public_path__ + "ki.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ki.svg
// module id = 892
// module chunks = 0